import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'react-toastify';
import './SignupProcess.css';
import boyImage from './Boy.svg';
import CompanyLogo from './images/CompanyLogo.svg';

const slogans = [
  "Hello there, superstar! What should we call you? (Your first name, please!)",
  "Awesome, {name}! What's your email for signing in?",
  "Cool beans, {name}! What's your go-to username? (Make it legendary!)",
  "Almost done, {name}! How can we reach you by phone?",
  "Final step, {name}! Create a super-secure password (no '12345' allowed!)"
];

const SignupProcess = () => {
  const [currentStep, setCurrentStep] = useState(0);
  const [userData, setUserData] = useState({
    firstName: '',
    email: '',
    username: '',
    mobile: '',
    password: ''
  });
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const blueCircleRef = useRef(null);
  const whiteCircleRef = useRef(null);
  const purpleCircleRef = useRef(null);

  useEffect(() => {
    const animateCircles = () => {
      const circles = [blueCircleRef, whiteCircleRef, purpleCircleRef];
      circles.forEach((ref, index) => {
        if (ref.current) {
          const speed = 0.5 + (index * 0.2);
          const angle = Date.now() * 0.001 * speed;
          const radius = 50 + (index * 20);
          const x = Math.cos(angle) * radius;
          const y = Math.sin(angle) * radius;
          ref.current.style.transform = `translate(${x}px, ${y}px)`;
        }
      });
      requestAnimationFrame(animateCircles);
    };

    animateCircles();
  }, []);

  const handleCreateAccount = async () => {
    try {
      setIsLoading(true);
      setErrors({});

      const formData = {
        firstName: userData.firstName,
        emailOrPhone: userData.email,
        username: userData.username,
        mobileNumber: userData.mobile,
        password: userData.password
      };

      const response = await axios.post(
        `http://34.47.145.31:8000/api/auth/signup`,
        formData,
        {
          headers: {
            'Content-Type': 'application/json'
          }
        }
      );

      if (response.status === 201) {
        toast.success('🎉 Account created successfully!', {
          position: "top-center",
          autoClose: 2000
        });

        // Wait for the toast to be visible
        await new Promise(resolve => setTimeout(resolve, 2000));

        // Navigate to login page
        navigate('/login', {
          state: {
            email: userData.email,
            justRegistered: true
          }
        });
      }
    } catch (error) {
      console.error('Signup error:', error);
      const errorMessage = error.response?.data?.message || 'Error creating account';
      toast.error(errorMessage);
      setErrors({ submit: errorMessage });
    } finally {
      setIsLoading(false);
    }
  };

  const handleNext = async (e) => {
    e.preventDefault();
    
    if (currentStep === 4) {
      await handleCreateAccount();
    } else {
      setCurrentStep(prev => prev + 1);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setUserData(prev => ({
      ...prev,
      [name]: value
    }));
    setErrors({});
  };

  const getCurrentInput = () => {
    switch (currentStep) {
      case 0:
        return (
          <input
            type="text"
            name="firstName"
            className="signup-form__input"
            placeholder="Enter your name"
            value={userData.firstName}
            onChange={handleChange}
            autoFocus
          />
        );
      case 1:
        return (
          <input
            type="email"
            name="email"
            className="signup-form__input"
            placeholder="Enter your email"
            value={userData.email}
            onChange={handleChange}
            autoFocus
          />
        );
      case 2:
        return (
          <input
            type="text"
            name="username"
            className="signup-form__input"
            placeholder="Choose a username"
            value={userData.username}
            onChange={handleChange}
            autoFocus
          />
        );
      case 3:
        return (
          <input
            type="tel"
            name="mobile"
            className="signup-form__input"
            placeholder="Enter your phone number"
            value={userData.mobile}
            onChange={handleChange}
            maxLength="10"
            autoFocus
          />
        );
      case 4:
        return (
          <input
            type="password"
            name="password"
            className="signup-form__input"
            placeholder="Create a password"
            value={userData.password}
            onChange={handleChange}
            autoFocus
          />
        );
      default:
        return null;
    }
  };

  return (
    <>
      <div className="logo-container">
        <img src={CompanyLogo} alt="DevOps Guy Logo" />
      </div>

      <div className="signup-process-container">
        <div className="slogan-container">
          {slogans[currentStep].replace('{name}', userData.firstName || 'friend')}
        </div>

        <div className="signup-box">
          <h1>
            Hey... <span role="img" aria-label="wave">👋</span>
          </h1>

          <form onSubmit={(e) => {
            e.preventDefault();
            handleNext(e);
          }}>
            {getCurrentInput()}

            {errors.submit && (
              <p className="error-message">{errors.submit}</p>
            )}

            <button 
              type="submit"
              className="signup-form__button"
              disabled={isLoading}
            >
              {isLoading ? (
                'Creating Account...'
              ) : (
                currentStep === 4 ? 'Create Account' : 'Next'
              )}
            </button>
          </form>
        </div>

        <div ref={blueCircleRef} className="animated-circle blue"></div>
        <div ref={whiteCircleRef} className="animated-circle white"></div>
        <div ref={purpleCircleRef} className="animated-circle purple"></div>

        <div className="character">
          <img src={boyImage} alt="Character illustration" />
        </div>
      </div>
    </>
  );
};

export default SignupProcess;